import { Radii } from './interfaces'

export const radii: Radii = {
  rectangle: 0,
  rounded: '4px',
  fullRounded: '50%',
}
